import ImageCircularAvatar from '@/components/UI/Avatar/ImageCircularAvatar';
import type { InternalTeam } from '@/types/Project';
import { getInitials } from '@/utils';

interface IDrawDetailsApprovers {
  invoiceApprover: InternalTeam;
  documentApprover: InternalTeam;
}

const renderApprovers = (approver: InternalTeam) => {
  return (
    <div className='flex -space-x-2'>
      <ImageCircularAvatar
        customClass='h-8 w-8'
        imageUrl={approver?.profileImageUrl as string}
        fallbackText={approver?.name && getInitials(approver?.name)}
      />
    </div>
  );
};

const DrawDetailsApprovers = ({ invoiceApprover, documentApprover }: IDrawDetailsApprovers) => {
  return (
    <div className='w-full grid grid-cols-2 border-t-2 py-6 px-6'>
      <div className='col-span-1 flex items-center gap-4'>
        <h2 className='text-lg'>Invoice Approver:</h2>
        {renderApprovers(invoiceApprover)}
      </div>
      <div className='col-span-1 justify-self-end flex items-center gap-4 mr-12'>
        <h2 className='text-lg'>Document Approver:</h2>
        {renderApprovers(documentApprover)}
      </div>
    </div>
  );
};

export default DrawDetailsApprovers;
